import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Helper } from "src/app/core/helpers/helper";
import { BookingService } from "../../services/booking.service";

@Component({
  selector: "app-trip-reassign-modal",
  templateUrl: "./trip-reassign-modal.component.html",
  styleUrl: "./trip-reassign-modal.component.scss",
  standalone: false
})
export class TripReassignModalComponent {
  modalRef!: NgbModalRef;
  isManually: number = this.helper.bookingDriverAssignEnum.NEAREST_DRIVER;
  driverId!: any;
  isSubmitted: boolean = false;
  nearestProvider: any = [];

  bookingDetails: any;
  bookingType: any;

  @Output() onReassign = new EventEmitter();
  @ViewChild("template", { static: true }) template!: TemplateRef<any>;
  constructor(public helper: Helper, private modalService: NgbModal, private bookingService: BookingService) {}

  /**
   * Opens the modal with the provided booking details.
   * Initializes the modal state and fetches the nearest provider.
   *
   * @param bookingDetails The details of the booking to be reassigned.
   */
  openModal(bookingDetails: any, bookingType: any = null): void {
    this.modalRef = this.modalService.open(this.template, { centered: true, backdrop: "static" });
    this.bookingDetails = bookingDetails;
    this.nearestProvider = [];
    this.driverId = null;
    this.isManually = this.helper.bookingDriverAssignEnum.NEAREST_DRIVER;
    this.bookingType = bookingType;
    this.getNearestProvider();
  }

  /**
   * Handles the change event for driver assignment method.
   * Prevents the checkbox from being unchecked if the condition is not met.
   *
   * @param assignManually Indicates if the assignment is manual.
   * @param event The event object from the change event.
   */
  onDriverAssignChange(assignManually: number, event: Event): void {
    this.isSubmitted = false;
    if ((assignManually && !this.isManually) || (!assignManually && this.isManually)) {
      this.isManually = assignManually;
    } else {
      event.preventDefault();
    }
  }

  /**
   * Fetches the nearest provider based on the booking details.
   * Sends a request to the booking service to get the nearest drivers.
   */
  getNearestProvider(): void {
    const params: any = {
      cityId: this.bookingDetails.cityId,
      pickupAddress: { latitude: this.bookingDetails.pickupAddress.latitude, longitude: this.bookingDetails.pickupAddress.longitude },
      destinationAddress: this.bookingDetails.destinationAddresses?.length
        ? {
            latitude: this.bookingDetails.destinationAddresses[this.bookingDetails.destinationAddresses.length - 1].latitude,
            longitude: this.bookingDetails.destinationAddresses[this.bookingDetails.destinationAddresses.length - 1].longitude
          }
        : undefined,
      vehicleTypeId: this.bookingDetails.vehicleTypeId,
      isShowErrorToast: false
    };

    if (this.bookingType === this.helper.BookingHistoryMainType.SCHEDULED) {
      params["isNowBooking"] = false;
    }

    params["isOffline"] = true;

    this.bookingService.getNearestDriver(params).subscribe((response: any) => {
      this.nearestProvider = response.drivers;
    });
  }

  /**
   * Closes the modal and resets the submission state.
   */
  closeModal(): void {
    this.modalRef.close();
    this.isSubmitted = false;
  }

  /**
   * Handles the assignment of the driver.
   * Emits the selected driver ID if the assignment is valid.
   */
  onAssign(): void {
    this.isSubmitted = true;
    if (this.isManually && !this.driverId) {
      return;
    }

    if (!this.isManually) {
      this.driverId = null;
    }

    this.onReassign.emit(this.driverId);
  }
}
